import * as Types from '../../graphql.generated';

import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type SaveTrackedPropertyMutationVariables = Types.Exact<{
    trackedProperty: Types.TrackedPropertyInput;
}>;

export type SaveTrackedPropertyMutation = { __typename?: 'Mutation' } & Pick<
    Types.Mutation,
    'saveTrackedProperty'
>;

export const SaveTrackedPropertyDocument = gql`
    mutation saveTrackedProperty($trackedProperty: TrackedPropertyInput!) {
        saveTrackedProperty(trackedProperty: $trackedProperty)
    }
`;
export type SaveTrackedPropertyMutationFn = Apollo.MutationFunction<
    SaveTrackedPropertyMutation,
    SaveTrackedPropertyMutationVariables
>;

/**
 * __useSaveTrackedPropertyMutation__
 *
 * To run a mutation, you first call `useSaveTrackedPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTrackedPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTrackedPropertyMutation, { data, loading, error }] = useSaveTrackedPropertyMutation({
 *   variables: {
 *      trackedProperty: // value for 'trackedProperty'
 *   },
 * });
 */
export function useSaveTrackedPropertyMutation(
    baseOptions?: Apollo.MutationHookOptions<
        SaveTrackedPropertyMutation,
        SaveTrackedPropertyMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        SaveTrackedPropertyMutation,
        SaveTrackedPropertyMutationVariables
    >(SaveTrackedPropertyDocument, options);
}
export type SaveTrackedPropertyMutationHookResult = ReturnType<
    typeof useSaveTrackedPropertyMutation
>;
export type SaveTrackedPropertyMutationResult =
    Apollo.MutationResult<SaveTrackedPropertyMutation>;
export type SaveTrackedPropertyMutationOptions = Apollo.BaseMutationOptions<
    SaveTrackedPropertyMutation,
    SaveTrackedPropertyMutationVariables
>;
